import { SystemUsageData } from "../../../../../types"
import Cell from "../../../billing-table/cell"
import HeaderCell from "../../../billing-table/header-cell"
import HeaderRow from "../../../billing-table/header-row"
import If from "../../../if"
import TableFooter from "../table-footer"
import TableWrapper from "../table-wrapper"

interface Props {
  usage: SystemUsageData
}

const LeadsBreakdown = ({ usage }: Props) => {
  return (
    <>
      <div className="pt-4">
        <strong>Total Leads:</strong> {usage?.breakdown.leads.total} (
        {usage?.pricing_details.included_leads} Included)
      </div>
      <If
        condition={
          !!usage?.breakdown?.cost?.breakdown?.leads?.breakdown[0]?.subtotal
        }
        then={
          <TableWrapper>
            <thead>
              <HeaderRow>
                <HeaderCell>LINE ITEM</HeaderCell>
                <HeaderCell className="text-center">RATE</HeaderCell>
                <HeaderCell className="text-center">COUNT</HeaderCell>
                <HeaderCell className="text-right">LINE TOTAL</HeaderCell>
              </HeaderRow>
            </thead>
            <tbody className="divide-y divide-zinc-200">
              {usage?.breakdown.cost.breakdown.leads.breakdown.map(
                (item, key) =>
                  item.subtotal && (
                    <tr key={key}>
                      <Cell>
                        <span>Tier {key + 1} Leads</span>
                        <br />
                        <small>
                          Lead count {item.start}{" "}
                          {item.stop ? `- ${item.stop}` : "+"}
                        </small>
                      </Cell>
                      <Cell className="text-center">${item.cpl}</Cell>
                      <Cell className="text-center">
                        {Math.round(item.subtotal / item.cpl)}
                      </Cell>
                      <Cell className="text-right">${item.subtotal}</Cell>
                    </tr>
                  )
              )}
            </tbody>

            <TableFooter
              subTotal={usage?.breakdown?.cost?.breakdown?.leads?.total}
            />
          </TableWrapper>
        }
        else={
          <TableWrapper>
            <TableFooter
              subTotal={usage?.breakdown?.cost?.breakdown?.leads?.total}
            />
          </TableWrapper>
        }
      />
    </>
  )
}

export default LeadsBreakdown
